import { useMemo, useState } from "react";
import {
  countdownLabel, dayNum, daysUntil, isUpcoming, monShort, sortEvents, tidyUrl, whenLine,
} from "../lib/format.js";
import AddToCalendar from "./AddToCalendar.jsx";

function EventCard({ ev, past }) {
  const soon = !past && daysUntil(ev.date) !== null && daysUntil(ev.date) <= 21;

  return (
    <article className="event">
      <div className="event-date">
        <b>{dayNum(ev.date)}</b>
        <span>{monShort(ev.date)}</span>
      </div>

      <div className="event-main">
        {soon ? <span className="event-tag">{countdownLabel(ev.date)}</span> : null}
        <h3>{ev.title}</h3>
        {ev.description ? <p>{ev.description}</p> : null}
        <div className="event-meta">
          <div>{whenLine(ev)}</div>
          {ev.location ? <div>{ev.location}</div> : null}
          {!past && ev.host ? <div>Gastgeber: {ev.host}</div> : null}
        </div>
      </div>

      {past ? null : (
        <div className="event-side">
          {ev.link ? (
            <a className="btn btn-sm" href={tidyUrl(ev.link)} target="_blank" rel="noreferrer">
              Anmelden
            </a>
          ) : (
            <a className="btn btn-ghost btn-sm" href="#mitmachen">
              Als Gast kommen
            </a>
          )}
          <AddToCalendar ev={ev} align="right" />
        </div>
      )}
    </article>
  );
}

export default function Events({ events, showPastEnabled }) {
  const [showPast, setShowPast] = useState(false);

  const { upcoming, past } = useMemo(() => {
    const up = events.filter((e) => isUpcoming(e.date)).sort(sortEvents.upcoming);
    const old = events.filter((e) => !isUpcoming(e.date)).sort(sortEvents.past);
    return { upcoming: up, past: old };
  }, [events]);

  const pastAllowed = showPastEnabled !== false && past.length > 0;

  return (
    <section className="section" id="anlaesse">
      <div className="wrap">
        <p className="eyebrow">Anlässe</p>
        <h2>Wo wir uns als Nächstes treffen.</h2>
        <p className="section-lead">
          Immer abends, immer in einer Bar oder einem Restaurant in Rapperswil-Jona und näherer
          Umgebung. Gäste sind willkommen, meldet euch kurz an.
        </p>

        {upcoming.length ? (
          <div className="event-list">
            {upcoming.map((e) => (
              <EventCard key={e.id} ev={e} />
            ))}
          </div>
        ) : (
          <p className="empty">
            Zurzeit ist kein Anlass ausgeschrieben. Der nächste Termin folgt in Kürze.
          </p>
        )}

        {pastAllowed ? (
          <div className="past-block">
            <button className="toggle" onClick={() => setShowPast((v) => !v)} aria-expanded={showPast}>
              {showPast
                ? "Vergangene Anlässe ausblenden"
                : `Vergangene Anlässe zeigen (${past.length})`}
            </button>
            {showPast ? (
              <div className="past-list">
                {past.map((e) => (
                  <EventCard key={e.id} ev={e} past />
                ))}
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    </section>
  );
}
